"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customRowColoredCell = (arg) => {
    const customCell = ({ dataItem, dataIndex, columnIndex, field, style }) => {
        const rowColor = arg.row.includes(dataIndex + 1);
        const itemData = dataItem;
        return ((0, jsx_runtime_1.jsx)("td", Object.assign({ role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, id: `m_grid_cell_is_active_${dataIndex}`, className: arg.locked ? 'k-grid-content-sticky' : '', style: Object.assign(Object.assign({}, style), { color: rowColor ? '#FFFFFF' : '#0D1F3E', backgroundColor: rowColor ? '#727272' : 'inherit' }) }, { children: (field === null || field === void 0 ? void 0 : field.includes('date'))
                ? dataItem[`date_${columnIndex && columnIndex - 4}`]
                : field && itemData[field].toString() })));
    };
    return customCell;
};
exports.default = customRowColoredCell;
